import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../../../app/stores/store";
import { BackendErrors } from "../../../enums/backendErrors";
import { ErrorState } from "../../../models/errors/errorState";

const initialState = { errors: [] as ErrorState[] };

const slice = createSlice({
  name: "errorNoticeSlice",
  initialState,
  reducers: {
    setError(state, { payload }: PayloadAction<ErrorState>) {
      const error = {
        type: payload.type,
        backendType: payload.backendType,
        message: payload.message,
      } as ErrorState;
      if (state.errors.some((e) => e.type === error.type)) {
        state.errors.map((errState) => (errState.type === payload.type ? error : errState));
      } else {
        state.errors.push(error);
      }
    },
    setDefaultAsyncError(state) {
      const noAsyncErrors = state.errors.filter((err) => err.type !== "async");
      state.errors = noAsyncErrors;
    },
    setDefaultError(state) {
      state.errors.splice(0, state.errors.length);
    },
  },
});

export const { setError, setDefaultAsyncError, setDefaultError } = slice.actions;

export default slice.reducer;

export const errorStatus = (state: RootState) => state.errorNoticeSlice;

export const selectErrorStatus = (state: RootState) => state.errorNoticeSlice;

export const selectIsAnyErrors = (state: RootState) => state.errorNoticeSlice.errors.length > 0;

export const selectIsAsyncError = (state: RootState) =>
  state.errorNoticeSlice.errors.find((err) => err.type === "async");

export const selectIsCommonError = (state: RootState) =>
  state.errorNoticeSlice.errors.find((err) => err.type === "common");

export const selectIsNoData = (state: RootState) =>
  state.errorNoticeSlice.errors.some((err) => err.backendType === BackendErrors.No_Data);

export const selectIsAuthExpiredOrMissingError = (state: RootState) =>
  state.errorNoticeSlice.errors.some((err) => err.backendType === BackendErrors.Auth_Expired_Or_Missing);
